
export enum PagesEnum {
    CutomerDeal = 0,
    Dashboard,
}
export function getPageDetails(page: PagesEnum): Page {
    return new Page({ navbarTitle: "Management Console", routeUrl: null });
}
export class Page {
    navbarTitle: string;
    routeUrl?: string;

    constructor({ navbarTitle, routeUrl }: { navbarTitle: string, routeUrl?: string }) {
        this.navbarTitle = navbarTitle;
        this.routeUrl = routeUrl;
    }
}

